import React from 'react'
import DescriptionField from 'react-jsonschema-form/lib/components/fields/DescriptionField'

// This modifies the built-in checkbox widget to accept
// HTML in the label and send True and False strings if checked or unchecked

// Check to see if a schema specifies that a value must be true
function schemaRequiresTrueValue(schema) {
  // Check if const is a truthy value
  if (schema.const) {
    return true
  }

  // Check if an enum has a single value of true
  if (schema.enum && schema.enum.length === 1 && schema.enum[0] === true) {
    return true
  }

  // If anyOf has a single value, evaluate the subschema
  if (schema.anyOf && schema.anyOf.length === 1) {
    return schemaRequiresTrueValue(schema.anyOf[0])
  }

  // If oneOf has a single value, evaluate the subschema
  if (schema.oneOf && schema.oneOf.length === 1) {
    return schemaRequiresTrueValue(schema.oneOf[0])
  }

  // Evaluate each subschema in allOf, to see if one of them requires a true
  // value
  if (schema.allOf) {
    return schema.allOf.some(schemaRequiresTrueValue)
  }
}

function AltCheckboxWidget(props) {
  const {
    schema,
    id,
    value,
    disabled,
    readonly,
    label,
    autofocus,
    onBlur,
    onFocus,
    onChange,
    options = { html: false },
  } = props
  const { html = false } = options
  const htmlLabel = { __html: label }

  // Because an unchecked checkbox will cause html5 validation to fail, only add
  // the "required" attribute if the field value must be "true", due to the
  // "const" or "enum" keywords
  const required = schemaRequiresTrueValue(schema)

  const handleChangeBoolean = event => onChange(event.target.checked)
  const handleChangeString = event => {
    const value = event.target.checked ? schema.enum[0] : schema.enum[1]
    onChange(value)
  }
  let handleChange = handleChangeBoolean
  let checked = typeof value === 'undefined' ? false : value
  if (schema.type === 'string') {
    handleChange = handleChangeString
    checked = value === schema.enum[0]
  }

  return (
    <div className={`checkbox ${disabled || readonly ? 'disabled' : ''}`}>
      {/*schema.description && (
        <DescriptionField description={schema.description} />
      )*/}
      <label>
        <input
          type="checkbox"
          id={id}
          checked={checked}
          required={required}
          disabled={disabled || readonly}
          autoFocus={autofocus}
          onChange={handleChange}
          onBlur={onBlur && (event => onBlur(id, event.target.checked))}
          onFocus={onFocus && (event => onFocus(id, event.target.checked))}
        />
        {html ? (
          <span dangerouslySetInnerHTML={htmlLabel} />
        ) : (
          <span>{label}</span>
        )}
      </label>
    </div>
  )
}

AltCheckboxWidget.defaultProps = {
  autofocus: false,
  options: {
    html: false,
  },
}

export default AltCheckboxWidget
